import { Alert } from 'app/store/Alerts/slice.types';
import { appStateMock } from 'app/utils/test/constants';

export const SNACKBAR_DEFAULT_CLOSE_TIME = 4000;

export const TEST_STATES = {
  getPreloadedState: (alert?: Partial<Alert>) => ({
    ...appStateMock,
    alerts: { queue: [{ message: 'TEST', ...alert }] },
  }),
};
